export default __webpack_public_path__ + "static/media/shopping-cart-nav.acd7065f.png";